import React from 'react';
import RouteOptimizationTabs from '../components/route-optimization/RouteOptimizationTabs';

const RouteOptimizationPage: React.FC = () => {
  return <RouteOptimizationTabs />;
};

export default RouteOptimizationPage;
